import { FormInstance } from "antd/lib/form";
import { MetricPerformanceTabs } from "./component/metric-performance-tabs";
import { MetricPerformanceContextProvider } from "@src/contexts/ab-testing/metric-performance-context";
import { AbTestExplorationContextProvider } from "@src/contexts/ab-testing/ab-test-exploration-context";
import { MetricStoreTabItem } from "./component/store-visual/metric-store-tab-item";
import { css } from "@emotion/react";
import { Collapse, Typography } from "antd";

export const MetricPerformance: React.FC<{ form: FormInstance<any> }> = ({ form }) => {
  return (
    <Collapse
      css={css`
        .ant-collapse-expand-icon {
          display: none !important;
        }
      `}
      className="ab-testing-collapse mb-4"
      activeKey={["metric-performance"]}
      items={[
        {
          key: "metric-performance",
          label: <Typography.Text strong>Metric performance</Typography.Text>,
          children: (
            <div
              css={css`
                .ant-tabs-nav {
                  margin: 0;
                  border-color: #1890ff !important;
                  border-width: 0px !important;
                  border-bottom-width: 1px !important;
                  border-style: solid !important;
                }
                .ant-tabs-tab-active {
                  border-bottom-width: 0px !important;
                }
                .ant-tabs-tab-remove {
                  display: none;
                }
              `}
            >
              <MetricStoreTabItem form={form} />
              <AbTestExplorationContextProvider>
                <MetricPerformanceContextProvider form={form}>
                  <MetricPerformanceTabs />
                </MetricPerformanceContextProvider>
              </AbTestExplorationContextProvider>
            </div>
          ),
        },
      ]}
    />
  );
};
